import { Routes } from '@angular/router';
import {Home} from './home/home';
import {Perfil} from './home/perfil/perfil';
import {Login} from './authentication/login/login';
import {NotFound} from './not-found/not-found';
import { authGuard } from '@core/auth/auth.guard';
import { moduleGuard, permissionGuard } from '@core/guards/module.guard';
import {AppLayout} from '../shared/layout/app-layout/app-layout';
import {Parametricos} from './home/modules/parametricos/parametricos';
// import {Laboratorio} from './home/modules/laboratorio/laboratorio';
import {Ubicacion} from './home/modules/ubicacion/ubicacion';
import {Prospectos} from './home/modules/crm/prospectos/prospectos';
import {CrearProspecto} from './home/modules/crm/prospectos/crear-prospecto/crear-prospecto';
import {DetalleProspecto} from './home/modules/crm/prospectos/detalle-prospecto/detalle-prospecto';
import {Clientes} from './home/modules/crm/clientes/clientes';
import {CrearCliente} from './home/modules/crm/clientes/crear-cliente/crear-cliente';
import {DetalleCliente} from './home/modules/crm/clientes/detalle-cliente/detalle-cliente';
import {DetalleEstablecimiento} from './home/modules/crm/establecimientos/detalle-establecimiento/detalle-establecimiento';
// import {CrearEstablecimiento} from './home/modules/crm/establecimientos/crear-establecimiento/crear-establecimiento';
import {ResetPassword} from './authentication/reset-password/reset-password';
import {Zonas} from './home/modules/ubicacion/zonas/zonas';
import {CrearZona} from './home/modules/ubicacion/zonas/crear-zona/crear-zona';
import {EditarZona} from './home/modules/ubicacion/zonas/editar-zona/editar-zona';
import {Direcciones} from './home/modules/ubicacion/direcciones/direcciones';
import {CrearDireccion} from './home/modules/ubicacion/direcciones/crear-direccion/crear-direccion';
import {EstablecimientosUbicacion} from './home/modules/ubicacion/establecimientos/establecimientos';
import { Agendamientos } from './home/modules/agendamientos/opu/agendamientos';
import { PiveHistorial } from './home/modules/pive/pive-historial/pive-historial';
import { DetalleAgendamiento } from './home/modules/agendamientos/opu/detalle-agendamiento/detalle-agendamiento';
import { DetalleCultivo } from './home/modules/pive/cultivos/detalle-cultivo/detalle-cultivo';
import { StockLaboratorio } from './home/modules/stock/stock';
import { DetalleStockVitrificado } from './home/modules/stock/embriones/detalle-stock-vitrificado/detalle-stock-vitrificado';

export const routes: Routes = [
  {
    path: '',
    component: AppLayout,
    canActivate: [authGuard],
    children: [
      { path: '', component: Home },
      { path: 'perfil', component: Perfil },
      {
        path: 'administracion',
        loadChildren: () => import('./home/modules/administracion/administracion.routes')
          .then(m => m.ADMINISTRACION_ROUTES),
      },
      {
        path: 'parametricos',
        loadChildren: () => import('./home/modules/parametricos/parametricos.routes')
          .then(m => m.PARAMETRICOS_ROUTES),
        canActivate: [moduleGuard('parametricos')]
      },
      {
        path: 'agendamientos',
        canActivate: [moduleGuard('agendamientos')],
        loadChildren: () => import('./home/modules/agendamientos/agendamientos.routes').then(m => m.AGENDAMIENTOS_ROUTES),
      },
      // {
      //   path: 'laboratorio',
      //   canActivate: [moduleGuard('laboratorio')],
      //   children: [
      //     {
      //       path: '',
      //       component: Laboratorio
      //     },
      //     {
      //       path: 'opu',
      //       // 2026-09-24: OPU se combinó con PIVE (las aspiraciones son su primer paso).
      //       children: [
      //         // { path: '', component: Agendamientos, data: { ambito: 'opu' } },
      //         // { path: ':id', component: DetalleAgendamiento, data: { ambito: 'opu' } },
      //         { path: '', redirectTo: '/laboratorio/agendamientos', pathMatch: 'full' },
      //         { path: ':id', redirectTo: '/laboratorio/agendamientos/:id' },
      //       ],
      //     },
      //     {
      //       path: 'agendamientos',
      //       children: [
      //         // 2026-09-23: la PIVE se ve por cliente, como el historial de producción del laboratorio.
      //         // {
      //         //   path: '',
      //         //   component: Agendamientos,
      //         //   data: { ambito: 'laboratorio' },
      //         // },
      //         {
      //           path: '',
      //           component: PiveHistorial,
      //         },
      //         {
      //           path: 'new',
      //           redirectTo: '/agendamientos/opu/new',
      //           pathMatch: 'full',
      //         },
      //         {
      //           path: ':idAgendamiento/cultivos/:idCultivo',
      //           component: DetalleCultivo,
      //         },
      //         {
      //           path: ':id',
      //           component: DetalleAgendamiento,
      //           data: { ambito: 'laboratorio' },
      //         }
      //       ]
      //     },
      //     {
      //       path: 'stock',
      //       children: [
      //         {
      //           path: '',
      //           component: StockLaboratorio,
      //         },
      //         {
      //           path: 'embriones/:id',
      //           component: DetalleStockVitrificado,
      //         }
      //       ]
      //     },
      //     // 2026-09-24: la TE se agenda en el calendario; el trabajo de laboratorio
      //     // (planilla, ejecución, diagnóstico) tiene su módulo propio.
      //     {
      //       path: 'transferencias',
      //       children: [
      //         // { path: '', redirectTo: '/agendamientos?tipo=TE', pathMatch: 'full' },
      //         {
      //           path: '',
      //           loadComponent: () => import('./home/modules/agendamientos/transferencias/transferencias').then(m => m.Transferencias),
      //         },
      //         { path: 'new', redirectTo: '/agendamientos/transferencias/new', pathMatch: 'full' },
      //         // { path: ':id', redirectTo: '/agendamientos/transferencias/:id' },
      //         {
      //           path: ':id',
      //           loadComponent: () => import('./home/modules/agendamientos/transferencias/detalle-transferencia/detalle-transferencia')
      //             .then(m => m.DetalleTransferencia),
      //           data: { ambito: 'laboratorio' },
      //         },
      //       ]
      //     }
      //   ]
      // },
      // 2026-10-08: 'laboratorio' se dividió en PIVE, TE y Stock, cada uno con su permiso.
      // Los links viejos (/laboratorio/...) redirigen a las rutas nuevas.
      {
        path: 'laboratorio',
        children: [
          { path: '', redirectTo: '/pive', pathMatch: 'full' },
          { path: 'opu', redirectTo: '/pive', pathMatch: 'full' },
          { path: 'opu/:id', redirectTo: '/pive/:id', pathMatch: 'full' },
          { path: 'agendamientos', redirectTo: '/pive', pathMatch: 'full' },
          { path: 'agendamientos/new', redirectTo: '/agendamientos/opu/new', pathMatch: 'full' },
          { path: 'agendamientos/:idAgendamiento/cultivos/:idCultivo', redirectTo: '/pive/:idAgendamiento/cultivos/:idCultivo', pathMatch: 'full' },
          { path: 'agendamientos/:id', redirectTo: '/pive/:id', pathMatch: 'full' },
          { path: 'stock', redirectTo: '/stock', pathMatch: 'full' },
          { path: 'stock/embriones/:id', redirectTo: '/stock/embriones/:id', pathMatch: 'full' },
          { path: 'transferencias', redirectTo: '/te', pathMatch: 'full' },
          { path: 'transferencias/new', redirectTo: '/agendamientos/transferencias/new', pathMatch: 'full' },
          { path: 'transferencias/:id', redirectTo: '/te/:id', pathMatch: 'full' },
        ],
      },
      {
        // 2026-09-23: la PIVE se ve por cliente, como el historial de producción del laboratorio.
        path: 'pive',
        canActivate: [moduleGuard('pive')],
        children: [
          { path: '', component: PiveHistorial },
          { path: 'new', redirectTo: '/agendamientos/opu/new', pathMatch: 'full' },
          { path: ':idAgendamiento/cultivos/:idCultivo', component: DetalleCultivo },
          { path: ':id', component: DetalleAgendamiento, data: { ambito: 'laboratorio' } },
        ],
      },
      {
        path: 'stock',
        canActivate: [moduleGuard('stock')],
        children: [
          { path: '', component: StockLaboratorio },
          { path: 'embriones/:id', component: DetalleStockVitrificado, canActivate: [moduleGuard('stock.congelados')] },
        ],
      },
      {
        // 2026-09-24: la TE se agenda en el calendario; el trabajo de laboratorio
        // (planilla, ejecución, diagnóstico) tiene su módulo propio.
        path: 'te',
        canActivate: [moduleGuard('te')],
        children: [
          {
            path: '',
            loadComponent: () => import('./home/modules/agendamientos/transferencias/transferencias').then(m => m.Transferencias),
          },
          { path: 'new', redirectTo: '/agendamientos/transferencias/new', pathMatch: 'full' },
          {
            path: ':id',
            loadComponent: () => import('./home/modules/agendamientos/transferencias/detalle-transferencia/detalle-transferencia')
              .then(m => m.DetalleTransferencia),
            data: { ambito: 'laboratorio' },
          },
        ],
      },
      {
        path: 'crm',
        children: [
          {
            path: '',
            redirectTo: 'clientes',
            pathMatch: 'full',
          },
          {
            path: 'prospectos',
            canActivate: [moduleGuard('prospectos')],
            children: [
              {
                path: '',
                component: Prospectos,
              },
              {
                path: 'new',
                component: CrearProspecto,
                canActivate: [permissionGuard('prospectos', 'create')],
              },
              {
                path: ':id',
                component: DetalleProspecto,
              }
            ]
          },
          {
            path: 'clientes',
            canActivate: [moduleGuard('clientes')],
            children: [
              {
                path: '',
                component: Clientes
              },
              {
                path: 'new',
                component: CrearCliente,
                canActivate: [permissionGuard('clientes', 'create')]
              },
              {
                path: ':id',
                children: [
                  {
                    path: '',
                    component: DetalleCliente
                  },
                  {
                    path: 'establecimientos',
                    children: [
                      // El alta se hace en línea desde la pestaña del cliente.
                      // {
                      //   path: 'new',
                      //   component: CrearEstablecimiento
                      // },
                      {
                        path: ':idEstablecimiento',
                        component: DetalleEstablecimiento
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: 'animales',
        loadChildren: () => import('./home/modules/animales/animales.routes')
          .then(m => m.animalesRoutes),
        canActivate: [moduleGuard('animales')]
      },
      {
        path: 'ubicacion',
        children: [
          {
            path: '',
            component: Ubicacion
          },
          {
            path: 'zonas',
            canActivate: [moduleGuard('zonas')],
            children: [
              {
                path: '',
                component: Zonas
              },
              {
                path: 'new',
                component: CrearZona,
                canActivate: [permissionGuard('zonas', 'create')]
              },
              {
                path: ':id',
                component: EditarZona,
                canActivate: [moduleGuard('zonas')]
              }
            ]
          },
          {
            path: 'direcciones',
            canActivate: [moduleGuard('parametricos.geografia')],
            children: [
              {
                path: '',
                component: Direcciones
              },
              // {
              //   path: 'new',
              //   component: CrearDireccion
              // },
              {
                path: ':id',
                component: CrearDireccion
              }
            ]
          },
          {
            path: 'establecimientos',
            component: EstablecimientosUbicacion,
            canActivate: [moduleGuard('clientes')]
          }
        ]
      },
    ]
  },
  { path: 'login', component: Login },
  {
    path: 'informes/transferencias/:id',
    canActivate: [authGuard],
    loadComponent: () => import('./home/modules/agendamientos/transferencias/informe-transferencia/informe-transferencia')
      .then(m => m.InformeTransferenciaPage),
  },
  { path: 'reset-password', component: ResetPassword },
  {
    path: 'no-autorizado',
    loadComponent: () => import('./authentication/no-autorizado/no-autorizado').then(m => m.NoAutorizadoComponent)
  },
  { path: '**', component: NotFound }
];
